<div class="mt-4" *ngIf="isReportsAvailable() || isChartsAvailable()">
  <mat-divider></mat-divider>
  <h1 class="mt-3">{{ 'exportData' | translate }}</h1>
  <div fxLayoutGap="8px">
    <button [disabled]="disabled" mat-icon-button *ngIf="departureFailuresReport" color="sims"
      matTooltip="{{'chosedepartureFailuresReport' | translate }}" (click)="openFailuresReportDialog()">
      <mat-icon svgIcon="punishment"></mat-icon>
    </button>

    <button [disabled]="disabled" mat-icon-button color="sims" *ngIf="passengerReport && settingsService.isPassengerReportEnabled()"
      matTooltip="{{ 'TICKETS_REPORT' | translate }}" (click)="openPassengerReportDialog()">
      <mat-icon svgIcon="table_view"></mat-icon>
    </button>

    <button [disabled]="disabled" mat-icon-button color="sims" *ngIf="isChartsAvailable()" matTooltip="{{ 'createChart' | translate }}"
      (click)="openEditorForChart()">
      <mat-icon svgIcon="addchart"></mat-icon>
    </button>

    <button [disabled]="disabled" mat-icon-button color="sims" *ngIf="isReportsAvailable()" matTooltip="{{ 'exportData' | translate }}"
      (click)="openEditorForTables()">
      <mat-icon svgIcon="receipt_long"></mat-icon>
    </button>

    <button [disabled]="disabled" mat-icon-button color="sims" *ngIf="playlistSummaryReport && isReportsAvailable()"
      matTooltip="{{ 'exportSummaryData' | translate }}" (click)="openEditorForSummaryTables()">
      <mat-icon svgIcon="report_summary"></mat-icon>
    </button>

    <button [disabled]="disabled" mat-icon-button *ngIf="(isReportsAvailable() || isChartsAvailable()) && settingsService.isScheduleEnabled()"
      color="sims" matTooltip="{{'scheduleOperations' | translate }}">
      <mat-icon svgIcon="schedule-icon" (click)="openEditorForm('scheduleOperations', true, reports)"></mat-icon>
    </button>
  </div>
</div>